import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { thanksgivingPromo } from '../data/promo';
interface PromoCountdownProps {
  tone?: 'dark' | 'gold';
  size?: 'sm' | 'lg';
}
export function PromoCountdown({
  tone = 'dark',
  size = 'sm'
}: PromoCountdownProps) {
  const {
    days,
    hours,
    minutes,
    seconds
  } = useCountdown(thanksgivingPromo.endsAt);
  const units = [{
    label: 'days',
    value: days
  }, {
    label: 'hrs',
    value: hours
  }, {
    label: 'min',
    value: minutes
  }, {
    label: 'sec',
    value: seconds
  }];
  const box = tone === 'dark' ? 'bg-ink text-gold' : 'bg-gold text-ink';
  const label = tone === 'dark' ? 'text-ink/70' : 'text-white/70';
  const boxSize = size === 'lg' ? 'min-w-[64px] px-2 py-2.5 text-3xl sm:min-w-[72px] sm:text-4xl' : 'min-w-[34px] px-1.5 py-1 text-[15px]';
  return <div role="timer" aria-label={`Promotion ends in ${days} days, ${hours} hours, ${minutes} minutes`} className={`flex items-start ${size === 'lg' ? 'gap-2.5' : 'gap-1.5'}`} data-id="element-564" data-mp="175mep4jrgp99">
      {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-565" data-mp="3j1zbf4l77wx4">
          <span className={`rounded-md text-center font-banner font-black tabular-nums leading-none ${box} ${boxSize}`} data-id="element-566" data-mp="3n3uae2fnpy7q">
            {String(unit.value).padStart(2, '0')}
          </span>
          <span className={`mt-1 font-semibold uppercase tracking-wide ${label} ${size === 'lg' ? 'text-[11px]' : 'text-[9px]'}`} data-id="element-567" data-mp="rx6ad4yjcn6">
            {unit.label}
          </span>
        </div>)}
    </div>;
}